export default function InstallCta() {
  return (
    <section id="cotizacion" className="py-14 md:py-20 px-4 md:px-8 lg:px-12 bg-[#0087a4] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-40 h-40 rounded-full bg-white blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-60 h-60 rounded-full bg-white blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center reveal">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight">
          &iquest;Necesitas instalar un aire acondicionado?
        </h2>
        <p className="text-white text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
          Cont&aacute;ctanos y un ingeniero certificado te asesorar&aacute; para elegir el equipo ideal y realizar la instalaci&oacute;n profesional que tu espacio necesita.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <a
            href="https://wa.me/573232209100"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3.5 rounded-lg bg-white text-[#0087a4] font-semibold text-sm md:text-base hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2" />
            Cotizar por WhatsApp
          </a>
        </div>
        <p className="text-white text-xs mt-5">
          Samsung &middot; LG &middot; Midea &middot; Mabe &middot; Mirage &middot; Garant&iacute;a de f&aacute;brica incluida
        </p>
      </div>
    </section>
  );
}